"use strict";

import angular from "angular";

import template from "./news-popover.component.html";
import "./news-popover.component.scss";

import { AccountingNewGateway } from "../../../gateway/AccountingNewGateway/AccountingNewGateway";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";

export class NewsPopoverComponent {
    AccountingNewGateway = new AccountingNewGateway();
    news = {};
    placement = null;
    afterHidePop = null;
    context = null;
    namePopOver = "AccountingNotification";
    user = new UserDataAdapter().user();

    constructor(
        $state,
        $stateParams,
        $scope,
        toast,
        $rootScope,
        AccountingNewsService
    ) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.toast = toast;
        this.$rootScope = $rootScope;
        this.AccountingNewsService = AccountingNewsService;
    }

    $onInit() {
        this.getNews();
        this.$scope.$on(
            `popOverInstance${this.namePopOver}`,
            (event, context) => {
                this.context = context;
            }
        );
        this.$rootScope.$on("FINISH_AUTO_ASSOCIATED_ACCOUNTS", () => {
            this.getNews();
        });
    }

    async getNews() {
        if (!this.accountingId) return;
        const response = await this.AccountingNewGateway.getNews({
            userId: this.user._id,
            accountingId: this.accountingId
        });

        this.news = response;
        this.AccountingNewsService.set(response);
    }

    hasNotification() {
        if (!this.news?.length) return false;
        return this.news.some((item) => !item.props.wasRead);
    }

    onRedirect(link, item) {
        if (!item.props.wasRead) {
            item.props.wasRead = true;
            this.onUpdateRead(item._id);
        }

        if (item.props.notificationCode === 22) {
            const href = this.$state.href(
                "nucont.accounting.company.dashboards.view",
                {
                    id: item.props.companyId,
                    accountingId: this.accountingId,
                    source: "contabil"
                }
            );
            window.open(href, "_blank");
            this.context.hide();
            return;
        }

        if (item.props.options?.link)
            window.open(item.props.options.link, "_blank");
        else if (link.uiSref?.length) this.$state.go(...link.uiSref);

        this.context.hide();
    }

    onUpdateRead(id) {
        this.AccountingNewGateway.updateRead({ ids: [id] });
    }
}

NewsPopoverComponent.$inject = [
    "$state",
    "$stateParams",
    "$scope",
    "toast",
    "$rootScope",
    "AccountingNewsService"
];

const name = "newsPopoverComponent";
const def = {
    bindings: {
        accountingId: "<"
    },
    controller: NewsPopoverComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
